import qs from "qs";
import { parseCountry, defaultCountries } from "react-international-phone";

export const hasEmptyValues = (data: any): boolean => {
  const settingsKeys = ["callSettings", "smsSettings", "emailSettings"];

  // 如果三个都没选
  const allUnchecked = settingsKeys.every((key) => !data[key]?.checked);
  if (allUnchecked) return true;

  let invalid = false;

  for (const key of settingsKeys) {
    const setting = data[key];
    if (setting?.checked) {
      //不同意直接不用看了  掀桌子了
      if (!setting.isAgree && setting.name !== "Email") {
        invalid = true;
        break;
      }

      for (const prop in setting) {
        if (prop === "checked" || prop === "name") continue;

        const value = setting[prop];

        // 如果是 emailSettings.email，要验证邮箱格式
        if (key === "emailSettings" && prop === "email") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
          if (!emailRegex.test(value)) {
            invalid = true;
            break; // 这个对象已经无效，没必要继续看
          }
        } else {
          // 空值检测（null、undefined、空字符串）
          if (value === "" || value === null || value === undefined) {
            invalid = true;
            break;
          }
        }
      }
    }
    if (invalid) break; // 如果发现无效，直接结束
  }

  return invalid;
};

export const getBrowserCountryCode = () => {
  const lang = navigator.language || navigator.language || "en";
  const parts = lang.split("-");
  if (parts.length === 2) {
    return parts[1].toLowerCase(); // "us", "cn", "fr" 等
  }
  return "us"; // 如果没有地区码，返回空字符串
};

export const filterCountries = defaultCountries.filter((country) => {
  const { iso2 } = parseCountry(country);
  const defaultAr = ["us", "gb", "fr", "mx", "br", "it", "de", "ca", "es"];
  return defaultAr.includes(iso2);
});

export const redirectParams = (redirect: any) => {
  if (!redirect) {
    return null;
  }
  if (redirect) {
    const queryString = new URL(redirect).search;
    const params = qs.parse(queryString, {
      ignoreQueryPrefix: true,
    });
    return params;
  }
};
